module.exports = __webpack_public_path__ + "static/media/profile1.704030b5.png";